var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",staticStyle:{"overflow-y":"scroll","overflow-x":"hidden"}},[(_vm.showLoading)?_c('div',{staticClass:"loading"},[_c('a-spin',{attrs:{"size":"large"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }